module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_blue_04-b4de10acffbe24c9062df8a7e085ce06.svg";